// Si REACT_APP_API_URL está definida (incluso vacía), usarla. Si no, usar localhost
export const API_BASE_URL = process.env.REACT_APP_API_URL !== undefined
  ? process.env.REACT_APP_API_URL
  : 'http://localhost:3001';

export const MONTHS = [
  "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
  "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
];

export const DEFAULT_VISIBLE_COLUMNS = ['Service Name', 'Instance Name', 'Cost'];

export const COST_COLUMNS = ['Original Cost', 'Cost', 'Volume Cost', 'Volume Discount'];
